module.exports = __webpack_public_path__ + "img/first-fail-back.6854fe77.png";